import ApiService from './apiService';
import { UserAccountCompensation } from '../models/userAccountCompensation';

class UserCompensationService extends ApiService {
  private static instance?: UserCompensationService;

  private constructor() {
    super();
  }

  static getInstance() {
    if (!UserCompensationService.instance) {
      UserCompensationService.instance = new UserCompensationService();
    }
    return UserCompensationService.instance;
  }

  getCurrentUserCompensations(): Promise<UserAccountCompensation[]> {
    return this.client.get(`/user-accounts/current/compensation`).then((response) => response.data);
  }

  getUserCompensations(userId: string): Promise<UserAccountCompensation[]> {
    return this.client.get(`/user-accounts/${userId}/compensation/all`).then((response) => response.data);
  }

  create(userId: string, compensation: UserAccountCompensation): Promise<void> {
    return this.client.post(`/user-accounts/${userId}/compensation`, compensation);
  }

  update(compensation: UserAccountCompensation): Promise<void> {
    return this.client.put(`user-accounts/compensation/${compensation.userAccountCompensationId}`, compensation);
  }

  delete(userId: string, compensationId: number): Promise<void> {
    return this.client.delete(`/user-accounts/${userId}/compensation/${compensationId}`);
  }
}

export default UserCompensationService;
